import UserApiTokenStoreUtil from "./user-api-token-store-util.js";

export default class {
	constructor() {
		this.store_util = UserApiTokenStoreUtil;
	}

	get_user_api_token() {
		return this.store_util.get_data();
	}
}
